var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "root-layout",
    { attrs: { moduleCode: _vm.moduleCode, subModuleCode: _vm.subModuleCode } },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-lilac-light ct-app-wrapper d-flex flex-column ct-header-fixed h-100",
          class: _vm.appClass,
        },
        [
          _c("div", { staticClass: "ct-root-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "ct-page-wrapper",
                class: { "no-header": !_vm.showHeader },
              },
              [
                _vm.hasMainSidebar
                  ? _c("div", { staticClass: "ct-aside ct-aside-fixed" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ct-aside-brand",
                          attrs: { id: "ct_aside_brand" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ct-aside-brand-logo" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: _vm.initialPagePlatform },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.assetsPathGlobalPlatform(
                                        "/logo-1.svg"
                                      ),
                                      width: "138px",
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ct-aside-menu-wrapper",
                          attrs: { id: "ct_aside_menu_wrapper" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ct-aside-menu" },
                            [_vm._t("aside-main-menu")],
                            2
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasMainSidebar
                  ? _c("div", {
                      staticClass: "ct-aside-overlay",
                      attrs: {
                        "data-action": "toggle",
                        "data-class": "mobile-nav-on",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.sidebarStatus = false
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ct-content-wrapper" },
                  [
                    _vm.showHeader
                      ? _c("header-nav", {
                          attrs: {
                            moduleCode: _vm.moduleCode,
                            hasNavTopMenu: _vm.hasNavTopMenu,
                            hasMainSidebarSlot: _vm.hasMainSidebar,
                            activeSearchPortal: _vm.activeSearchPortal,
                            showBorderTopLeft:
                              _vm.hasMainSidebar && !_vm.mainSidebarOnlyMobile,
                          },
                          on: { toggleClick: _vm.toggleSideBar },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasNavTopMenu &&
                    !(_vm.hasMainSidebar && !_vm.mainSidebarOnlyMobile)
                      ? _c("top-menu-dashboard", {
                          attrs: {
                            moduleCode: _vm.moduleCode,
                            isStatic: _vm.staticTopMenuDashboard,
                            isFixed: _vm.fixedTopMenuDashboard,
                          },
                          on: { toggleClick: _vm.toggleSideBar },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ct-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ct-container container-fluid",
                          class: [_vm.moduleCode, _vm.containerClasses],
                        },
                        [
                          _vm._t("breadcrumb"),
                          _vm._v(" "),
                          _vm._t("content-top"),
                          _vm._v(" "),
                          _vm._t("main"),
                          _vm._v(" "),
                          _vm.hasSidebarControlSlot
                            ? [_vm._t("aside-control")]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("modal-confirmation", {
                            ref: "modalConfirmation",
                          }),
                          _vm._v(" "),
                          _c("modal-prompt", { ref: "modalPrompt" }),
                          _vm._v(" "),
                          _c("modal-export", { ref: "modalExport" }),
                          _vm._v(" "),
                          _c("modal-info", { ref: "modalInfo" }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.showFooter ? _vm._t("footer") : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }